export const UPDATE_RESIDENT = 'UPDATE_RESIDENT';
export const UPDATE_INVESTMENT_YEARS = 'UPDATE_INVESTMENT_YEARS';
export const UPDATE_INVESTMENT_PROFILE = 'UPDATE_INVESTMENT_PROFILE';
export const UPDATE_TEMPORARY_DROP_PERCENTAGE = 'UPDATE_TEMPORARY_DROP_PERCENTAGE';
export const  UPDATE_DEPENDANTS ='UPDATE_DEPENDANTS';
export const UPDATE_ADDRESSLINE = 'UPDATE_ADDRESSLINE';
